import { formatCPF } from 'services/utils/format_cpf';

export const formatUserDetails = (user: any, viewFullCPF: boolean) => {
  return {
    personalData: {
      name: user.name,
      cpf: formatCPF(user.identification, viewFullCPF),
      email: user.email,
      phone: user.contactList?.[0]?.value,
      position: user.position,
      occupation: user.occupation ?? '',
      municipality: user.address?.municipality,
    },
    loginData: {
      group: user.permission?.profile?.group,
      profile: user.permission?.profile,
      permission: user.permission,
    },
    registrationData: {
      activeRegistration: user.isRegisterActive ? 'SIM' : 'NÃO',
      blockRegistration: user.isRegisterBlocked ? 'SIM' : 'NÃO',
      termData: user.termStartDate
        ? {
          termStartDate: user.termStartDate,
          termEndDate: user.termEndDate,
          termEndDateIndefinite: user.termEndDateIndefinite,
        }
        : null,
    },
  };
};

export const parseValidityDates = (validityData: any) => {
  if (validityData?.dataInicial && validityData?.dataFinal) {
    const convertInitialDate = validityData.dataInicial ? validityData.dataInicial.split('-') : [];
    const convertFinalDate = validityData.dataFinal ? validityData.dataFinal.split('-') : [];

    if (convertInitialDate.length === 3 && convertFinalDate.length === 3) {
      const initialDate = `${convertInitialDate[2]}/${convertInitialDate[1]}/${convertInitialDate[0]}`;
      const finalDate = `${convertFinalDate[2]}/${convertFinalDate[1]}/${convertFinalDate[0]}`;
      return { initialDate, finalDate, indeterminate: !!validityData.vigenciaIndeterminada };
    }
    return { initialDate: '', finalDate: '', indeterminate: false };
  }
  return { initialDate: '', finalDate: '', indeterminate: false };
};

export const shouldShowFileSection = (permissionName?: string) => {
  if (!permissionName) return false;
  const name = permissionName.trim().toUpperCase();
  return (
    name === 'REPRESENTANTE LEGAL MUNICIPAL' ||
    name === 'AGRICULTOR FAMILIAR' ||
    name === 'REPRESENTANTE LEGAL MUNICIPAL'
  );
};

export const isMunicipalRepresentative = (permissionName?: string) => {
  return permissionName?.trim().toUpperCase() === 'REPRESENTANTE LEGAL MUNICIPAL';
};
